<template>
	<div class="homeOuter">
		<!--导航条-->
		<navZcy v-bind:num="1" style="min-width: 1050px;"></navZcy>
		<div class="line"></div>
		<div class="home">
			<div class="top cf">
				<div class="topL fl"><span>系统首页</span></div>
				<div class="topR fr">
					<el-button type="success" plain @click="refresh"><i class="el-icon-refresh" style="color: #666;"></i>刷新</el-button>
				</div>
			</div>
			<div class="line"></div>
			<div class="middle">
				<div class="addData">
					<el-row :gutter="50">
						<el-col :span="6">
							<div class="numOuter fl">
								<div class="imgOuter fl">
									<img src="../assets/img/home/icon/amountIcon.png" />
								</div>
								<div class="title fl">
									<span>今日新增供应商</span><br />
									<span>{{supplierDetailMount.currentAdd}}</span>
								</div>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="numOuter fl">
								<div class="imgOuter fl">
									<img src="../assets/img/home/icon/collectIcon.png" />
								</div>
								<div class="title fl">
									<span>今日新增零件数目</span><br />
									<span>{{companyDetailMount.currentAdd}}</span>
								</div>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="numOuter fl">
								<div class="imgOuter fl">
									<img src="../assets/img/home/icon/addIcon.png" />
								</div>
								<div class="title fl">
									<span>今日新增灯组数目</span><br />
									<span>{{projectCaculateMount.currentAdd}}</span>
								</div>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="numOuter fl">
								<div class="imgOuter fl">
									<img src="../assets/img/home/icon/tagIcon.png" />
								</div>
								<div class="title fl">
									<span>今日新增方案数目</span><br />
									<span>{{caculateMount}}</span>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
				<div class="speedyEntry">
					<div class="headline">便捷入口</div>
					<div class="entryIcon">
						<el-row style="text-align: center;">
							<el-col :span="6">
								<router-link to="/partGroup">
									<div class="entryImg">
										<img src="../assets/img/home/icon/addIcon2.png" />
									</div>
									<div>灯组方案</div>
								</router-link>
							</el-col>
							<el-col :span="6">
								<router-link to="/seriesTag">
									<div class="entryImg">
										<img src="../assets/img/home/icon/homeIcon.png" />
									</div>
									<div>系列表管理</div>									
								</router-link>
							</el-col>
							<el-col :span="6">
								<router-link to="/frimTag">
									<div class="entryImg">
										<img src="../assets/img/home/icon/adminIcon.png" />
									</div>
									<div>供应商管理</div>
								</router-link>
							</el-col>
							<el-col :span="6">
								<router-link to="/part">
									<div class="entryImg">
										<img src="../assets/img/home/icon/collectIcon2.png" />
									</div>
									<div>零件列表</div>
								</router-link>
							</el-col>
						</el-row>
					</div>
				</div>
				<div class="pandect">
					<el-row :gutter="100">
						<el-col :span="12">
							<div class="pandectOuter">
								<div class="headline">
									供应商总览
								</div>
								<div class="pandectNum">
									<el-row style="text-align: center;">
										<el-col :span="6">
											<div class="num">{{supplierDetailMount.currentAdd}}</div>
											<div>今日新增</div>
										</el-col>
										<el-col :span="6">
											<div class="num">{{supplierDetailMount.yesterdayAdd}}</div>
											<div>昨日新增</div>
										</el-col>
										<el-col :span="6">
											<div class="num">{{supplierDetailMount.mountAdd}}</div>
											<div>本月新增</div>
										</el-col>
										<el-col :span="6">
											<div class="num">{{supplierDetailMount.supplierCount}}</div>
											<div>供应商总数</div>
										</el-col>
									</el-row>
								</div>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="pandectOuter">
								<div class="headline">
									零件总览
								</div>
								<div class="pandectNum">
									<el-row style="text-align: center;">
										<el-col :span="6">
											<div class="num">{{companyDetailMount.currentAdd}}</div>
											<div>今日新增</div>
										</el-col>
										<el-col :span="6">
											<div class="num">{{companyDetailMount.yesterdayAdd}}</div>
											<div>昨日新增</div>
										</el-col>
										<el-col :span="6">
											<div class="num">{{companyDetailMount.mountAdd}}</div>
											<div>本月新增</div>
										</el-col>
										<el-col :span="6">
											<div class="num">{{companyDetailMount.componentCount}}</div>
											<div>零件总数</div>
										</el-col>
									</el-row>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
				<div class="echart">
					<div class="headline">灯组统计</div>
					<div class="echartMain">
						<div class="mainL fl">
							<div class="">本月新增</div>
							<div style="font-size: 30px;">{{projectCaculateMount.currentMonthAdd}}</div>
							<div style="line-height: 25px;">
								<i :class="projectCaculateMount.currentMonthAdd>=projectCaculateMount.lastMonthAdd?'el-icon-caret-top top':'el-icon-caret-bottom bottom'"></i><span>{{projectCaculateMount.monthAdd}}% 同比上月</span>
							</div>
							<div>本周新增</div>
							<div style="font-size: 30px;">{{projectCaculateMount.currentWeekAdd}}</div>
							<div>
								<i :class="projectCaculateMount.currentWeekAdd>=projectCaculateMount.lastWeekAdd?'el-icon-caret-top top':'el-icon-caret-bottom bottom'"></i><span>{{projectCaculateMount.weekAdd}}% 同比上周</span>
							</div>
						</div>
						<div class="mainR fl cf">
							<div class="chartTitle">近一周灯组统计</div>
							<div id="lineChart" style="width: 800px;height: 240px;padding: 0;"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import navZcy from './nav'
// 引入基本模板
let echarts = require('echarts/lib/echarts')
// 引入线状图组件
require('echarts/lib/chart/line')

// 引入提示框和title组件
require('echarts/lib/component/tooltip')
export default {
	data() {
		return {
			lineData: {},           //线状图参数
			supplierDetailMount: {},//供应商数量情况总览参数
			companyDetailMount: {}, //零件数量情况总览参数
			caculateMount: 0,		//方案数量情况总览参数
			projectCaculateMount: {}
		}
	},
	methods: {
		refresh() {
			location.reload();
		},
		sessionTimeout(msg) {
			this.$message({
				type: 'error',
				message: msg
			});
			this.$router.push({path: '/',query: ''})  
		},
		//供应商数量情况总览
		queryUsrDetailMountFn(data) {
			this.supplierDetailMount = data.data
		},
		queryUsrDetailMount() {
			let url = "/lightApi/indexDetail/supplierDetail/"+sessionStorage.getItem('sessionId')
			this.$store.dispatch('handleGet',{'url': url,'Fn': this.queryUsrDetailMountFn,'vue':this})
		},
		//零件数量情况总览
		queryCompanyDetailMountFn(data) {
			this.companyDetailMount = data.data
		},
		queryCompanyDetailMount() {
			let url = "/lightApi/indexDetail/componentDetail/"+sessionStorage.getItem('sessionId')
			this.$store.dispatch('handleGet',{'url': url,'Fn': this.queryCompanyDetailMountFn,'vue':this})
		},
		//方案情况总览
		queryCaculateMount() {
			this.$http.get("/lightApi/indexDetail/houseProjectDetail/"+sessionStorage.getItem('sessionId'), {}, {emulateJson: true}).then(
				(data) => {
					this.caculateMount = data.body.data
				},
				(error) => {
					this.$message({
						type: 'error',
						message: '数据连接失败'
					});
				}
			)
		},
		//灯组案例数量情况总览
		queryProjectCaculateMount() {
			this.$http.get("/lightApi/indexDetail/lightGroupDetail/"+sessionStorage.getItem('sessionId'), {}, {emulateJson: true}).then(
				(data) => {
					this.projectCaculateMount = data.body.data
					let currentMonthAdd = this.projectCaculateMount.currentMonthAdd
					let lastMonthAdd = this.projectCaculateMount.lastMonthAdd
					let currentWeekAdd = this.projectCaculateMount.currentWeekAdd
					let lastWeekAdd = this.projectCaculateMount.lastWeekAdd
					this.projectCaculateMount.monthAdd = 0
					this.projectCaculateMount.weekAdd = 0
					if(currentMonthAdd!=0){
						if(currentMonthAdd>lastMonthAdd){
							this.projectCaculateMount.monthAdd = Math.round(Math.abs(currentMonthAdd-lastMonthAdd)/currentMonthAdd*100)
						}else{
							this.projectCaculateMount.monthAdd = Math.round(Math.abs(currentMonthAdd-lastMonthAdd)/lastMonthAdd*100)
						}						
					}
					if(currentWeekAdd!=0){
						if(currentWeekAdd>lastWeekAdd){
							this.projectCaculateMount.weekAdd = Math.round(Math.abs(currentWeekAdd-lastWeekAdd)/currentWeekAdd*100)
						}else{
							this.projectCaculateMount.weekAdd = Math.round(Math.abs(currentWeekAdd-lastWeekAdd)/lastWeekAdd*100)
						}
					}
					this.lineData={
						xAxis_data: [],
						series_data: []
					}
					let week = ['日', '一', '二', '三', '四', '五', '六']
					let oDay = new Date().getDay()
					for (let i=0; i<7; i++) {
						oDay--
						if(oDay<0){
							oDay=6
						}
						this.lineData.xAxis_data[6-i] = "周"+ week[oDay]
					}
					this.lineData.series_data = this.projectCaculateMount.lastWeekCount
					this.drawLine('lineChart',this.lineData)
				},
				(error) => {
					this.$message({
						type: 'error',
						message: '数据连接失败'
					});
				}
			)
		},
		drawLine(drawId,data) {
			let optionData = {
				"tooltip": {
					"show": true
				},
				"calculable": true,
				"xAxis": {
					"boundaryGap": false,
					"data": data.xAxis_data
				},
				"yAxis": {},
				"series": [{
					"name": '灯饰收藏',
					"type": 'line',
					"symbol": 'emptyCircle',
					"itemStyle": {
						"normal": {},
						"emphasis": {
							"label": {
								"show": true
							}
						}
					},
					"data": data.series_data
				}],
			}
			let lineChart = echarts.init(document.getElementById(drawId));
			lineChart.setOption(optionData);
		}
	},
	mounted() {
		this.queryProjectCaculateMount()
		this.queryUsrDetailMount()
		this.queryCompanyDetailMount()
		this.queryCaculateMount()
	},
	components: {
		navZcy
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fl {
	float: left;
}

.fr {
	float: right;
}

.cf {
	overflow: hidden;
}
a{
	color: #333;
}
.line {
	height: 10px;
}

.home {
	width: 1036px;
	margin: 0 auto;
}

.top {
	line-height: 40px;
	color: #999;
}

.topL span {
	border-left: 4px solid rgb(26, 188, 156);
	padding: 0 5px;
}

.btn {
	color: #999;
}

.el-icon-refresh {
	margin-right: 10px;
}

.middle {
	padding: 0 20px;
}

.addData .numOuter {
	width: 100%;
	height: 77px;
	background: #fff;
	border: 1px solid #ccc;
}

.numOuter .imgOuter {
	vertical-align: middle;
	height: 77px;
	line-height: 77px;
	padding: 0 10px;
}

.numOuter .imgOuter img {
	vertical-align: middle;
}

.numOuter .title {
	padding-top: 20px;
	line-height: 23px;
}

.speedyEntry {
	border: 1px solid #ccc;
	margin: 30px 0;
	color: #666;
}

.speedyEntry .headline {
	background: #ededed;
	padding: 5px 10px;
	border-bottom: 1px solid #ccc;
}

.speedyEntry .entryIcon {
	height: 143px;
	background: #fff;
}

.entryIcon .entryImg {
	height: 60px;
	line-height: 60px;
	margin-bottom: 10px;
	margin-top: 25px;
}

.entryIcon .entryImg img {
	vertical-align: bottom;
}

.pandectOuter {
	border: 1px solid #ccc;
	color: #666;
}

.pandectOuter .headline {
	background: #ededed;
	padding: 5px 10px;
	border-bottom: 1px solid #ccc;
}

.pandectOuter .pandectNum {
	height: 165px;
	background: #fff;
	padding: 0 30px;
}

.pandectOuter .pandectNum .num {
	font-size: 36px;
	color: red;
	line-height: 50px;
	margin-top: 35px;
}

.echart {
	border: 1px solid #ccc;
	margin: 30px 0;
	color: #666;
}

.echart .headline {
	background: #ededed;
	padding: 5px 10px;
	border-bottom: 1px solid #ccc;
}

.echart .echartMain {
	height: 216px;
	background: #fff;
}

.echartMain .mainL {
	text-align: center;
	width: 169px;
	height: 194px;
	padding-top: 23px;
	border-right: 1px solid #ccc;
}

.el-icon-caret-top.top,
.el-icon-caret-bottom.bottom {
	font-size: 24px;
}

.el-icon-caret-top.top {
	display: inline-block;
	vertical-align: middle;
	color: green;
}

.el-icon-caret-bottom.bottom {
	color: red;
}

.mainR {
	position: relative;
}

.mainR .chartTitle {
	position: absolute;
	top: 16px;
	left: 26px;
}
</style>


// WEBPACK FOOTER //
// src/components/main.vue